import React from "react";
import { useSelector } from "react-redux";
import { deviceTypes } from "../../../enums/deviceTypes";
import Widget from "../../features/widget/Widget";
import Icon from "../../ui/icons/Icon";
import iconsList from "../../ui/icons/iconsList";
import NavigateLink from "../../features/navigateLink/navigateLink";
import { resolveBucketImageSrc } from "../../../utils/utils";
import classes from "./SchoolImageWidget.module.css";

const SchoolImageWidget = () => {

    const schoolData = useSelector(state => state.auth?.userDetails?.defaultSchool);
    const { deviceType } = useSelector(state => state.responsive);

    if (deviceType === deviceTypes.mobile)
        return (
            <Widget
                className={classes.SchoolImageWidgetMobile}
                contentScrollable={false}
            >
                <div className={classes.SchoolImageContent}>
                    <img src={resolveBucketImageSrc(schoolData?.imageUrl)} alt={schoolData?.name} className={classes.SchoolImageMobile} />
                </div>
            </Widget>
        );

    return (
        <NavigateLink link={schoolData?.imageLink}>
            <div className={classes.SchoolImageWidget}>
                <img src={resolveBucketImageSrc(schoolData?.imageUrl)} alt={schoolData?.name} className={classes.SchoolImage} />
                <div className={classes.Gradient} />
                <span className={classes.SchoolName}>{schoolData?.name}</span>
                {schoolData?.imageLink &&
                    <div className={classes.ArrowsLink}>
                        <Icon name={iconsList.arrows} size="27px" color="white" />
                    </div>
                }
            </div>
        </NavigateLink>
    );
};

export default SchoolImageWidget;
